var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRightRoundActive = function SvgRightRoundActive(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 512",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 257.277,
    cy: 255.234,
    r: 241.948,
    style: {
      fill: "rgb(95,185,97)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.401,0 0,114.269 0,256C0,397.731 114.269,512 256,512C397.731,512 512,397.731 512,256C512,114.269 397.601,0 256,0ZM256,477.77C133.14,477.77 34.229,378.858 34.229,255.998C34.229,133.139 133.142,34.227 256,34.227C378.858,34.227 477.771,133.139 477.771,255.998C477.771,378.858 378.86,477.77 256,477.77Z",
    style: {
      fill: "rgb(95,185,97)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.836,245.719L237.259,133.142C230.492,126.375 220.209,126.375 213.312,133.142C206.545,139.909 206.545,150.191 213.312,157.09L312.224,256.002L213.312,354.913C206.545,361.68 206.545,371.962 213.312,378.86C216.696,382.243 220.079,383.935 225.286,383.935C228.67,383.935 233.877,382.243 238.951,380.551L349.836,269.666C353.22,266.282 354.913,262.899 354.913,257.692C354.913,252.616 353.221,249.103 349.836,245.719Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightRoundActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right-round-active.740e5594.svg";
export { ForwardRef as ReactComponent };